import CircularProgress from '@mui/material/CircularProgress'
import React from 'react'


export function LoadingProgress() {
  return <CircularProgress color="primary" size={30} />
}
